import React, { useContext, useMemo } from 'react'
import { ButtonPrimary } from 'components/Button'
import { AutoColumn } from 'components/Column'
import { SwapPoolTabs, Tabs } from 'components/NavigationTabs'
import PositionList from 'components/PositionList'
import { useActiveWeb3React } from 'hooks'
import { useV3Positions } from 'hooks/useV3Positions'
import { Inbox } from 'react-feather'
import { useTranslation } from 'react-i18next'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { useWalletModalToggle } from 'state/application/hooks'
import { ThemeContext } from 'styled-components'
import { HideSmall, TYPE } from 'theme'
import {
  ButtonRow,
  LoadingRows,
  MainContentWrapper,
  NoLiquidity,
  PageWrapper,
  ResponsiveButtonPrimary,
  TitleRow,
} from './styleds'
import IntroCard from 'components/IntroCard'
import { Helmet } from 'react-helmet'
import { StyledTabButton } from 'pages/FarmPool'
import PoolV2 from './v2'

function useIsPoolV2() {
  const location = useLocation()

  return useMemo(() => {
    return location.pathname.startsWith('/pool/v2')
  }, [location.pathname])
}

export default function Pool() {
  const { account } = useActiveWeb3React()
  const history = useHistory()
  const isV2 = useIsPoolV2()

  const toggleWalletModal = useWalletModalToggle()
  const { t } = useTranslation()
  const theme = useContext(ThemeContext)

  const { positions, loading: positionsLoading } = useV3Positions(account)

  return (
    <>
      <Helmet>
        <title>My Pool Positions | HyperSwap Exchange on Hyperliquid</title>
        <meta
          name="description"
          content="Manage your liquidity positions on HyperSwap Exchange with real-time data. Built on Hyperliquid's EVM for fast and reliable DeFi operations."
        />
        <meta
          name="keywords"
          content="HyperSwap pool positions, Hyperliquid blockchain, DeFi tools, liquidity positions, manage pools, Hyperliquid EVM"
        />
        <meta property="og:title" content="My Pool Positions | HyperSwap Exchange on Hyperliquid" />
        <meta
          property="og:description"
          content="Track and optimize your liquidity pool positions on HyperSwap Exchange, built on Hyperliquid."
        />
        <meta property="og:url" content={`${window.location.origin}/#/pool`} />
      </Helmet>
      <PageWrapper>
        <IntroCard variant={1} key="pool">
          <h1>Your Positions Overview</h1>
          <p>Manage your liquidity pools and view your positions.</p>
        </IntroCard>
        <SwapPoolTabs active={'pool'} />
        <AutoColumn gap="lg" justify="center">
          <AutoColumn gap="lg" style={{ width: '100%' }}>
            <TitleRow style={{ marginTop: '1rem' }} padding={'0'}>
              <HideSmall>
                <TYPE.mediumHeader>{t('Pools Overview')}</TYPE.mediumHeader>
              </HideSmall>
              <ButtonRow>
                <ResponsiveButtonPrimary id="join-pool-button" as={Link} to="/add/HYPE">
                  + {t('New Position')}
                </ResponsiveButtonPrimary>
              </ButtonRow>
            </TitleRow>
            <div style={{ display: 'flex', gap: '4px', justifyContent: 'flex-start' }}>
              <Tabs>
                <StyledTabButton isActive={isV2} onClick={() => history.push('/pool/v2')}>
                  Standard AMM
                </StyledTabButton>
                <StyledTabButton isActive={!isV2} onClick={() => history.push('/pool')}>
                  Concentrated Liquidity
                </StyledTabButton>
              </Tabs>
            </div>
            {isV2 ? (
              <>
                <PoolV2 />
              </>
            ) : (
              <>
                <MainContentWrapper>
                  {positionsLoading ? (
                    <LoadingRows>
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                      <div />
                    </LoadingRows>
                  ) : positions && positions.length > 0 ? (
                    <PositionList positions={positions} />
                  ) : (
                    <NoLiquidity>
                      <TYPE.mediumHeader color={theme.text3} textAlign="center">
                        <Inbox size={48} strokeWidth={1} style={{ marginBottom: '.5rem' }} />
                        <div>{t('Your V3 liquidity positions will appear here.')}</div>
                      </TYPE.mediumHeader>
                      {!account ? (
                        <ButtonPrimary style={{ marginTop: '2em', padding: '8px 16px' }} onClick={toggleWalletModal}>
                          {t('Connect a wallet')}
                        </ButtonPrimary>
                      ) : (
                        <>
                          {/*  <ButtonGray
                            as={Link}
                            to="/migrate/v2"
                            id="import-pool-link"
                            style={{
                              marginTop: '2em',
                              padding: '8px 16px',
                              borderRadius: '12px',
                              width: 'fit-content',
                            }}
                          >
                            {t('Migrate V2 liquidity')}?&nbsp;&nbsp;
                            <Download size={16} />
                          </ButtonGray> */}
                        </>
                      )}
                    </NoLiquidity>
                  )}
                </MainContentWrapper>
              </>
            )}
          </AutoColumn>
        </AutoColumn>
      </PageWrapper>
    </>
  )
}
